import React from 'react'
import { Table } from '../../../components/ui/Table'
import { updateStatusString } from '../../../constants/update_status'
import { format } from 'date-fns'
import { adTypeString } from '../../../config'
import { axiosGet } from '../../../util/api'
import { LoadFunc, useTableHooks } from '../../../packages/blueprint-components/src/useTableHooks'
import { Link } from 'react-router-dom'
import Update = Models.Update
import { Column } from '../../../types/table'

export const RecentlyFailedUpdatesTable = () => {
    const load: LoadFunc<Update> = (params: any) => {
        return axiosGet('admin/recently-failed-updates', params)
    }

    const tableHooks = useTableHooks(load)

    const columns: Column<Update, any>[] = [
        {
            key: 'id',
            title: 'Update Id',
            cell: ({ id }) => <Link to={`/admin/updates/${id}`}>{id}</Link>,
        },
        {
            key: 'profile_id',
            cell: ({ profile_id }) => (
                <Link to={`/admin/profiles/${profile_id}`}>{profile_id}</Link>
            ),
        },
        {
            key: 'status_id',
            title: 'Status',
            cell: (row) => {
                return (
                    <span className="whitespace-nowrap">{updateStatusString(row.status_id)}</span>
                )
            },
        },
        {
            key: 'created_at',
            cell: (row) => {
                return (
                    <span className="whitespace-nowrap">
                        {format(new Date(row.created_at), 'M/d/yy H:mm a')}
                    </span>
                )
            },
        },
        {
            key: 'marketplace_id',
            title: 'Marketplace',
        },
        {
            key: 'platform_type_id',
            title: 'Platform',
            cell: (row) => {
                return adTypeString(row.platform_type_id)
            },
        },
    ]

    return (
        <Table
            name="Recent Failures"
            showHeader
            className=""
            filters={null}
            canSelect={false}
            columnSelection={false}
            columns={columns}
            tableHooks={tableHooks}
            onSelectChange={null}
            height={400}
        />
    )
}
